<template>
    <div class="z-20" :style="style" style="aspect-ratio: 1 / 1">
        <div class="absolute">
            <img :src="avatar" class="rounded-full w-1/3 h-1/3" alt="pet" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'StudentStationPet',
};
</script>
<script setup>
import { computed, reactive, ref, watch } from 'vue';
import anime from 'animejs';
const stationPosition = (i, offSet = 2) => {
    const map = {
        0: 0,
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 3,
        6: 2,
        7: 1,
    };

    return map[(i + offSet) % 8];
};

const props = defineProps({
    avatar: {
        type: String,
        required: true,
    },
    index: {
        type: Number,
        required: true,
    },
});
const actualIndex = ref(props.index);

const position = reactive({
    x: stationPosition(actualIndex.value, 1) * 100,
    y: actualIndex.value * 100,
});

watch(
    () => props.index,
    (n) => {
        setTimeout(() => {
            anime({
                targets: position,
                x: stationPosition(n, 1) * 100,
                y: n * 100,
                round: 1,
                easing: 'easeInOutBack',
                duration: 650,
            });
        }, 250);
    },
);

const style = computed(() => {
    return {
        transform: `translate(${position.x}%, ${position.y}%)`,
    };
});
</script>
